export const GET_SERVICE_DETAIL = 'GET_SERVICE_DETAIL'

import ServiceDetailApi from '../../../apis/service'

export default {
  // eslint-disable-next-line no-unused-vars
  [GET_SERVICE_DETAIL]({ commit }, menuNo) {
    return  ServiceDetailApi.getServiceDetail(menuNo)
  }
}